/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PagedModelRequest } from './pagedModelRequest';
import { ARTransactionDetailsHoldingViewModel } from './aRTransactionDetailsHoldingViewModel';
import { PagedListMetaData } from './pagedListMetaData';

export interface ARTransactionDetailsHoldingViewModelPagedModelResponse {
  pagedRequest?: PagedModelRequest;
  data?: Array<ARTransactionDetailsHoldingViewModel> | null;
  metaData?: PagedListMetaData;
}
